import { SuiteManifest } from '../manifest';
import { sisRoutes } from './routes';

export const sisManifest: SuiteManifest = {
  id: 'sis',
  code: 'S2_SIS',
  name: 'Student Management',
  basePath: '/sis',
  icon: 'users',
  description: 'Student lifecycle, personal learner hub, gamified honors & rewards, verified tutor hiring, session OTPs, and syllabus mastery.',
  requiredPermission: 'students.read',
  nav: [
    { label: 'Learner Dashboard', path: '/sis/dashboard', icon: 'sparkles', group: 'Student Experience', status: 'live' },
    { label: 'Hire a Tutor', path: '/sis/hire-tutor', icon: 'graduation-cap', group: 'Tuition & Tutors', status: 'live' },
    { label: 'My Tutors & Class OTP', path: '/sis/my-tutors', icon: 'user-check', group: 'Tuition & Tutors', status: 'live' },
    { label: 'Faculty & Tutors Admin', path: '/sis/tutors-admin', icon: 'award', group: 'Tuition & Tutors', status: 'live', allowedRoles: ['owner', 'admin', 'branch_head'] },
    { label: 'Topic & Syllabus Mastery', path: '/sis/topics', icon: 'book-open', group: 'Student Experience', status: 'live' },
    { label: 'Student Directory', path: '/sis/students', icon: 'users', group: 'Directory', status: 'live', allowedRoles: ['owner', 'admin', 'branch_head', 'teacher', 'counselor', 'accountant'] },
    { label: 'Student Profile & Pass', path: '/sis/profile', icon: 'user', group: 'Student Experience', status: 'live' },
    { label: 'Rewards & Gamification', path: '/sis/rewards', icon: 'trophy', group: 'Student Experience', status: 'live' },
    { label: 'Course Enrollments', path: '/sis/enrollments', icon: 'book-open', group: 'Enrollment', status: 'live', allowedRoles: ['owner', 'admin', 'branch_head', 'teacher', 'counselor'] },
    { label: 'Attendance & Smart Cards', path: '/sis/attendance', icon: 'credit-card', group: 'Operations', status: 'live' },
  ],
  routes: sisRoutes,
};

export default sisManifest;
